module.exports = __webpack_public_path__ + "static/img/login_password.d83c1d1.svg";


//////////////////
// WEBPACK FOOTER
// ./yotta-vue-components/vision/assets/login_password.svg
// module id = EgFc
// module chunks = 3